import React from "react";
import AlertCustom from "../../alert/AlertCustom";

interface PasswordFormAlertInterface {
    state: {
        isError: boolean,
        message: string,
        errorMessage: string,
    },
}

const PasswordFormAlert = ({state}: PasswordFormAlertInterface) => {
  return (
    <>
      <AlertCustom
        heading={false}
        variant={(!state.isError) ? 'success' : 'danger'}
        bodyContent={(state.message) ?? state.errorMessage}
        transition={(Boolean(state.message) || Boolean(state.errorMessage))}
        dismissible={false}
      />
    </>
  )
}

export default PasswordFormAlert
